import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=0996bf5c&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0996bf5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0996bf5c')) {
      api.createRecord('0996bf5c', component.options)
    } else {
      api.reload('0996bf5c', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=0996bf5c&scoped=true&", function () {
      api.rerender('0996bf5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2j2Mx8JWRO4zO/JS/comp/Voucher-Unit.vue"
export default component.exports